import Box from "@mui/material/Box";
import { grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import {
	calculateGptValue,
	calculateMarginPlusOhValue,
	calculateTansportChargesValue,
	calculateTotalRow,
	calculateWastagePercentValue,
	checkForTotalColumn,
	tableRowTypes,
	tableColumns,
} from "./data";
import { Button, Typography } from "@mui/material";
import { EditRounded } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { DisabledBox, TotalBox, totalQtyColumn, WhiteBgBox } from "../data";
import { datatypes } from "data/globalData";
import { GlobalState } from "context/GlobalContext";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import { AuthState } from "context/AuthContext";
const colStyle = {
	headerAlign: "center",
	align: "center",
	minWidth: 133,
	flex: 1,
};

export const ValueWithUnitBox = ({ field, row }) => {
	let rowType = row[tableColumns.category.key] ?? "";
	let value = row[field] ?? "";
	let bg = "white";
	if (tableRowTypes?.[rowType]?.value_type === "percent") value = value + "%";

	// if (rowType === garmentDefTotalRow.category) return <DisabledBox field={field} row={row} />;

	return (
		<Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center" sx={{ background: bg }}>
			<span>{value}</span>
		</Box>
	);
};

const CostTable = ({
	rows,
	setRows,
	totalRow,
	setTotalRow,
	garmentTotalObj,
	optionDetails,
	mode = "" || "create" || "edit",
	editMode = false,
	setEditMode = () => {},
	handleSave = () => [],
}) => {
	const { snackBar, setLoadingOpen, setSnackBarOpen, setSnackBar } = GlobalState();
	const { user } = AuthState();

	const defTableColumns = [
		{
			...colStyle,
			...tableColumns.category,
			headerName: tableColumns.category.name,
			field: tableColumns.category.key,
			renderCell: ({ field, row }) => {
				if (checkForTotalColumn(row)) return <TotalBox field={field} row={row} />;
				return <DisabledBox field={field} row={row} />;
			},
			colSpan: (value, row) => {
				if (checkForTotalColumn(row)) {
					return 2;
				}
				return undefined;
			},
		},
		{
			...colStyle,
			...tableColumns.price,
			headerName: tableColumns.price.name,
			field: tableColumns.price.key,
			editable: true,
			renderCell: ({ field, row }) => {
				if (checkForTotalColumn(row)) return <TotalBox field={field} row={row} />;

				return <ValueWithUnitBox field={field} row={row} />;
			},
		},
		{
			...colStyle,
			headerName: tableColumns.value.name,
			field: tableColumns.value.key,
			renderCell: ({ field, row }) => {
				if (checkForTotalColumn(row)) return <TotalBox field={field} row={row} />;
				return <DisabledBox field={field} row={row} />;
			},
		},
	];

	const [tableColumnsState, setTableColumnsState] = useState([]);
	const [rowsCopy, setRowsCopy] = useState(rows ? [...rows] : []);
	const [deletedRowIds, setDeletedRowIds] = useState([]);

	const calculateRowValue = (row, garmentTotalObj) => {
		// if (row?.category === tableRowTypes.margin_plus_oh.key)
		// 	return { ...row, value: calculateMarginPlusOhValue(row, garmentTotalObj?.value) };
		// if (row?.category === tableRowTypes.wastage.key)
		// 	return { ...row, value: calculateWastagePercentValue(row, garmentTotalObj?.value) };
		// if (row?.category === tableRowTypes.transport_charges.key)
		// 	return { ...row, value: calculateTansportChargesValue(row, garmentTotalObj?.value) };
		// if (row?.category === tableRowTypes.gpt.key)
		// 	return { ...row, value: calculateGptValue(row, Number(optionDetails?.[totalQtyColumn.key]) ?? 0) };
		return { ...row, value: row.price };
	};

	useEffect(() => {
		setTableColumnsState([
			...defTableColumns,
			//  deleteTableColumn(handleDeleteRowClick, (row) => checkForTotalColumn(row))
		]);
		setTotalRow(calculateTotalRow([garmentTotalObj, ...rows]));
	}, []);
	useEffect(() => {
		if (garmentTotalObj?.value > 0) {
			setRows((prev) => {
				const calculated = prev.map((row) => {
					return calculateRowValue(row, garmentTotalObj);
				});
				setTotalRow(calculateTotalRow([garmentTotalObj, ...calculated]));
				return calculated;
			});
		}
	}, [garmentTotalObj?.value, optionDetails?.[totalQtyColumn.key]]);

	const processRowUpdate = (newRow, oldRow) => {
		try {
			let correct = true;
			// checking for NAN Values
			Object.values(tableColumns)?.forEach((col) => {
				if (col.data_type === datatypes.NUMBER.key || col.data_type === datatypes.DECIMAL.key)
					if (isNaN(newRow[col.key])) correct = false;
			});
			if (correct) {
				let updatedNewRow = calculateRowValue(newRow, garmentTotalObj);
				setRows((prev) => {
					let newRows = prev.map((row) => {
						if (row.id === updatedNewRow.id) return { ...updatedNewRow, is_updated: true, last_updated_by: user.email };
						else return row;
					});
					setTotalRow(calculateTotalRow([garmentTotalObj, ...newRows]));
					return newRows;
				});
				return updatedNewRow;
			} else {
				setSnackBar({
					...snackBar,
					message: "Please Enter Proper Values",
					severity: "warning",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setSnackBarOpen(true);
			}
		} catch (error) {
			console.log(error, "sabdasmdbas");
		}
	};
	const handleCancelEditClick = () => {
		setRows(rowsCopy);
		setEditMode(false);
	};
	const handleEditClick = () => {
		setEditMode(true);
	};
	const handleSaveClick = async () => {
		try {
			setLoadingOpen(true);
			const result = await handleSave(rows, deletedRowIds);
			if (result) {
				setRows(result);
				setRowsCopy(result);
				setDeletedRowIds([]);
				setEditMode(false);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Data Saved Successfully",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoadingOpen(false);
			}
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrorMessage(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};

	return (
		<Box>
			<Box display="flex" justifyContent="space-between" pt={1} pb={1}>
				<Typography variant="h6"> Cost Details </Typography>
				<Box display="flex" columnGap="5px">
					{mode === "create" ? (
						<></>
					) : mode === "edit" ? (
						<>
							{editMode ? (
								<>
									<Button variant="outlined" size="small" onClick={handleCancelEditClick}>
										Cancel Edit
									</Button>
									<Button variant="contained" size="small" onClick={handleSaveClick}>
										Save
									</Button>
								</>
							) : (
								<Button variant="contained" size="small" onClick={handleEditClick} startIcon={<EditRounded />}>
									Edit
								</Button>
							)}
						</>
					) : (
						<></>
					)}
				</Box>
			</Box>
			<Box width="100%">
				<DataGrid
					rows={[...(garmentTotalObj ? [garmentTotalObj] : []), ...(rows || []), ...(totalRow?.category ? [totalRow] : [])]}
					getRowId={(row) => row.category + "_" + row.value}
					columns={tableColumnsState}
					sx={{
						width: "100%",
						"& .MuiDataGrid-row": {
							cursor: "pointer",
						},
						"& .MuiDataGrid-row:hover": {
							backgroundColor: "transparent",
						},
						"& .MuiDataGrid-columnHeader": {
							cursor: "pointer",
							background: grey[400],
						},
						"& .MuiDataGrid-cell": {
							padding: 0,
						},
					}}
					disableRowSelectionOnClick
					pagination={false} // Remove footer
					hideFooter={true}
					showCellVerticalBorder
					showColumnVerticalBorder
					density="compact"
					isCellEditable={({ row }) => !checkForTotalColumn(row) && (mode === "create" || editMode)}
					processRowUpdate={processRowUpdate}
					autoHeight
				/>
			</Box>
		</Box>
	);
};

export default CostTable;
